<div role="navigation" [attr.aria-label]="appTilesLandmarkAriaLabel" class="app-tiles-list-component" @fadeOut>
    <div *ngIf="showProvisioningAlert"
         class="tiles-section__alert--fluent ms-fcl-nd"
         [ngStyle]="{ 'color': fullBleedFontColor }">
        <ohp-alert-message [message]="provisioningAlertText"></ohp-alert-message>
    </div>
    <div class="tiles-section__container mobile-tiles-section__container">
        <div class="mobile-tiles--outer">
            <div class="fluent-tiles mobile-tiles--inner">
                <ng-container *ngIf="workloads">
                    <cdk-virtual-scroll-viewport itemSize="100" maxBufferPx="100" minBufferPx="50" orientation="horizontal" class="virtual-scroll-tiles">
                        <div class="tiles__content" *cdkVirtualFor="let workload of workloads | slice:0:getDisplayedAppTilesCount(); let i = index; trackBy: trackByWorkloadId">
                            <ohp-app-tile *ngIf="!isConsumer" [workload]="workload" [inExpandedView]="i >= reducedTilesCount" [forceWhiteBackground]="fullBleedTheming"></ohp-app-tile>
                            <ohp-app-tile *ngIf="isConsumer" [workload]="workload" [inExpandedView]="false"></ohp-app-tile>
                        </div>
                    </cdk-virtual-scroll-viewport>
                </ng-container>
            </div>
        </div>
        <div *ngIf="showAppGalleryLink && !bottomTrayEnabled"
             class="explore-apps--fluent"
             [ngClass]="{'explore-apps--backplate': fullBleedBackplateEnabled}">
            <a id="explore-your-apps"
               class="explore-apps__text--fluent ms-fcl-tda ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a"
               [ngClass]="{'explore-apps__text--backplate': fullBleedBackplateEnabled}"
               [ngStyle]="fullBleedBackplateStyle"
               [attr.aria-label]="exploreYourAppsAriaLabel"
               [attr.data-area]="componentArea"
               [attr.data-nav]="true"
               (click)="navigateToAppsPage($event)"
               href="#"
               [ohpPreload]="appGalleryRoute"
               #appGalleryLink>
                <div class="centered-flex-container">
                    <span>{{ exploreYourAppsText }}</span>
                    <ohp-icon-font iconFontName="ArrowRight" size="14" cssClass="link-arrow"></ohp-icon-font>
                </div>
            </a>
        </div>
    </div>
</div>
